module.exports = __webpack_public_path__ + "static/media/iconfinder_microphone_mic_record_micro_2848306.155e30ef.svg";